import {connect} from 'react-redux';
import SuccessModal from '../../../Components/Modals/SuccessModal';
import {MODALS} from '../../../constants';
import {close} from '../../../modules/modal';

const mapStateToProps = (state, ownProps) => {
  const {modal: {visible, modalType, data} = {}} = state;
  console.log('Success modal ownProp', ownProps);
  return {
    visible: visible && modalType === MODALS.SUCCESS_MODAL,
    ...data,
    modalType,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    close: () => dispatch(close()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessModal);
